import { render, staticRenderFns } from "./DashboardActivityHeatmap.vue?vue&type=template&id=45a186af&scoped=true"
import script from "./DashboardActivityHeatmap.vue?vue&type=script&lang=js"
export * from "./DashboardActivityHeatmap.vue?vue&type=script&lang=js"
import style0 from "./DashboardActivityHeatmap.vue?vue&type=style&index=0&id=45a186af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a186af",
  null
  
)

export default component.exports